/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
import e, { useLayoutEffect as t, useEffect as o, createContext as l, useState as r, useCallback as n, useMemo as i, useContext as c, useRef as s, useImperativeHandle as a } from "react";
import { arrow as u, computePosition as d, offset as p, flip as v, shift as m, autoUpdate as f } from "@floating-ui/dom";
import y from "classnames";
const h = "react-tooltip-core-styles",
  w = "react-tooltip-base-styles",
  b = {
    core: !1,
    base: !1
  };
function S(_ref) {
  let {
    css: e,
    id: t = w,
    type: o = "base",
    ref: l
  } = _ref;
  var r, n;
  if (!e || "undefined" == typeof document || b[o]) return;
  if ("core" === o && "undefined" != typeof process && (null === (r = null === process || void 0 === process ? void 0 : process.env) || void 0 === r ? void 0 : r.REACT_TOOLTIP_DISABLE_CORE_STYLES)) return;
  if ("base" !== o && "undefined" != typeof process && (null === (n = null === process || void 0 === process ? void 0 : process.env) || void 0 === n ? void 0 : n.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  "core" === o && (t = h), l || (l = {});
  const {
    insertAt: i
  } = l;
  if (document.getElementById(t)) return;
  const c = document.head || document.getElementsByTagName("head")[0],
    s = document.createElement("style");
  s.id = t, s.type = "text/css", "top" === i && c.firstChild ? c.insertBefore(s, c.firstChild) : c.appendChild(s), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(document.createTextNode(e)), b[o] = !0;
}
function g() {
  let {
    type: e = "base",
    id: t = w
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!b[e]) return;
  "core" === e && (t = h);
  const o = document.getElementById(t);
  "style" === (null == o ? void 0 : o.tagName) ? null == o || o.remove() : console.warn(`[react-tooltip] Failed to remove 'style' element with id '${t}'. Call \`injectStyle()\` first`), b[e] = !1;
}
const E = async _ref2 => {
    let {
      elementReference: e = null,
      tooltipReference: t = null,
      tooltipArrowReference: o = null,
      place: l = "top",
      offset: r = 10,
      strategy: n = "absolute",
      middlewares: i = [p(Number(r)), v({
        fallbackAxisSideDirection: "start"
      }), m({
        padding: 5
      })],
      border: c,
      arrowSize: s = 8
    } = _ref2;
    if (!e) return {
      tooltipStyles: {},
      tooltipArrowStyles: {},
      place: l
    };
    if (null === t) return {
      tooltipStyles: {},
      tooltipArrowStyles: {},
      place: l
    };
    const a = i;
    return o ? (a.push(u({
      element: o,
      padding: 5
    })), d(e, t, {
      placement: l,
      strategy: n,
      middleware: a
    }).then(_ref3 => {
      let {
        x: e,
        y: t,
        placement: o,
        middlewareData: l
      } = _ref3;
      var r, n;
      const i = {
          left: `${e}px`,
          top: `${t}px`,
          border: c
        },
        {
          x: a,
          y: u
        } = null !== (r = l.arrow) && void 0 !== r ? r : {
          x: 0,
          y: 0
        },
        d = null !== (n = {
          top: "bottom",
          right: "left",
          bottom: "top",
          left: "right"
        }[o.split("-")[0]]) && void 0 !== n ? n : "bottom",
        p = c && {
          borderBottom: c,
          borderRight: c
        };
      let v = 0;
      if (c) {
        const e = `${c}`.match(/(\d+)px/);
        v = (null == e ? void 0 : e[1]) ? Number(e[1]) : 1;
      }
      return {
        tooltipStyles: i,
        tooltipArrowStyles: {
          left: null != a ? `${a}px` : "",
          top: null != u ? `${u}px` : "",
          right: "",
          bottom: "",
          ...p,
          [d]: `-${s / 2 + v}px`
        },
        place: o
      };
    })) : d(e, t, {
      placement: "bottom",
      strategy: n,
      middleware: a
    }).then(_ref4 => {
      let {
        x: e,
        y: t,
        placement: o
      } = _ref4;
      return {
        tooltipStyles: {
          left: `${e}px`,
          top: `${t}px`
        },
        tooltipArrowStyles: {},
        place: o
      };
    });
  },
  A = (e, t) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t),
  _ = (e, t, o) => {
    let l = null;
    const r = function () {
      for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
        r[_key] = arguments[_key];
      }
      const n = () => {
        l = null, o || e.apply(this, r);
      };
      o && !l && (e.apply(this, r), l = setTimeout(n, t)), o || (l && clearTimeout(l), l = setTimeout(n, t));
    };
    return r.cancel = () => {
      l && (clearTimeout(l), l = null);
    }, r;
  },
  O = e => null !== e && !Array.isArray(e) && "object" == typeof e,
  k = (e, t) => {
    if (e === t) return !0;
    if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((e, o) => k(e, t[o]));
    if (Array.isArray(e) !== Array.isArray(t)) return !1;
    if (!O(e) || !O(t)) return e === t;
    const o = Object.keys(e),
      l = Object.keys(t);
    return o.length === l.length && o.every(o => k(e[o], t[o]));
  },
  T = e => {
    if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
    const t = getComputedStyle(e);
    return ["overflow", "overflow-x", "overflow-y"].some(e => {
      const o = t.getPropertyValue(e);
      return "auto" === o || "scroll" === o;
    });
  },
  L = e => {
    if (!e) return null;
    let t = e.parentElement;
    for (; t;) {
      if (T(t)) return t;
      t = t.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  },
  C = "undefined" != typeof window ? t : o,
  R = e => {
    e.current && (clearTimeout(e.current), e.current = null);
  },
  x = "DEFAULT_TOOLTIP_ID",
  N = {
    anchorRefs: new Set(),
    activeAnchor: {
      current: null
    },
    attach: () => {},
    detach: () => {},
    setActiveAnchor: () => {}
  },
  $ = l({
    getTooltipData: () => N
  }),
  I = _ref5 => {
    let {
      children: t
    } = _ref5;
    const [o, l] = r({
        [x]: new Set()
      }),
      [c, s] = r({
        [x]: {
          current: null
        }
      }),
      a = function (e) {
        for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          t[_key2 - 1] = arguments[_key2];
        }
        l(o => {
          var l;
          const r = null !== (l = o[e]) && void 0 !== l ? l : new Set();
          return t.forEach(e => r.add(e)), {
            ...o,
            [e]: new Set(r)
          };
        });
      },
      u = function (e) {
        for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          t[_key3 - 1] = arguments[_key3];
        }
        l(o => {
          const l = o[e];
          return l ? (t.forEach(e => l.delete(e)), {
            ...o
          }) : o;
        });
      },
      d = n(function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : x;
        var t, l;
        return {
          anchorRefs: null !== (t = o[e]) && void 0 !== t ? t : new Set(),
          activeAnchor: null !== (l = c[e]) && void 0 !== l ? l : {
            current: null
          },
          attach: function () {
            for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              t[_key4] = arguments[_key4];
            }
            return a(e, ...t);
          },
          detach: function () {
            for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              t[_key5] = arguments[_key5];
            }
            return u(e, ...t);
          },
          setActiveAnchor: t => ((e, t) => {
            s(o => {
              var l;
              return (null === (l = o[e]) || void 0 === l ? void 0 : l.current) === t.current ? o : {
                ...o,
                [e]: t
              };
            });
          })(e, t)
        };
      }, [o, c, a, u]),
      p = i(() => ({
        getTooltipData: d
      }), [d]);
    return e.createElement($.Provider, {
      value: p
    }, t);
  };
function z() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : x;
  return c($).getTooltipData(e);
}
const j = _ref6 => {
  let {
    tooltipId: t,
    children: l,
    className: r,
    place: n,
    content: i,
    html: c,
    variant: a,
    offset: u,
    wrapper: d,
    events: p,
    positionStrategy: v,
    delayShow: m,
    delayHide: f
  } = _ref6;
  const {
      attach: h,
      detach: w
    } = z(t),
    b = s(null);
  return o(() => (h(b), () => {
    w(b);
  }), []), e.createElement("span", {
    ref: b,
    className: y("react-tooltip-wrapper", r),
    "data-tooltip-place": n,
    "data-tooltip-content": i,
    "data-tooltip-html": c,
    "data-tooltip-variant": a,
    "data-tooltip-offset": u,
    "data-tooltip-wrapper": d,
    "data-tooltip-events": p,
    "data-tooltip-position-strategy": v,
    "data-tooltip-delay-show": m,
    "data-tooltip-delay-hide": f
  }, l);
};
var B = {
    tooltip: "core-styles-module_tooltip__3vRRp",
    fixed: "core-styles-module_fixed__pcSol",
    arrow: "core-styles-module_arrow__cvMwQ",
    noArrow: "core-styles-module_noArrow__xock6",
    clickable: "core-styles-module_clickable__ZuTTB",
    show: "core-styles-module_show__Nt9eE",
    closing: "core-styles-module_closing__sGnxF"
  },
  D = {
    tooltip: "styles-module_tooltip__mnnfp",
    arrow: "styles-module_arrow__K0L3T",
    dark: "styles-module_dark__xNqje",
    light: "styles-module_light__Z6W-X",
    success: "styles-module_success__A2AKt",
    warning: "styles-module_warning__SCK0X",
    error: "styles-module_error__JvumD",
    info: "styles-module_info__BWdHW"
  };
const q = _ref7 => {
    let {
      forwardRef: t,
      id: l,
      className: i,
      classNameArrow: c,
      variant: u = "dark",
      anchorId: d,
      anchorSelect: p,
      place: v = "top",
      offset: m = 10,
      events: h = ["hover"],
      openOnClick: w = !1,
      positionStrategy: b = "absolute",
      middlewares: S,
      wrapper: g,
      delayShow: A = 0,
      delayHide: O = 0,
      float: T = !1,
      hidden: x = !1,
      noArrow: N = !1,
      clickable: $ = !1,
      closeOnEsc: I = !1,
      closeOnScroll: j = !1,
      closeOnResize: q = !1,
      openEvents: H,
      closeEvents: M,
      globalCloseEvents: W,
      imperativeModeOnly: P,
      style: V,
      position: F,
      afterShow: K,
      afterHide: U,
      disableTooltip: X,
      content: Y,
      contentWrapperRef: G,
      isOpen: Z,
      defaultIsOpen: J = !1,
      setIsOpen: Q,
      activeAnchor: ee,
      setActiveAnchor: te,
      border: oe,
      opacity: le,
      arrowColor: re,
      arrowSize: ne = 8,
      role: ie = "tooltip"
    } = _ref7;
    var ce;
    const se = s(null),
      ae = s(null),
      ue = s(null),
      de = s(null),
      pe = s(null),
      [ve, me] = r({
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: v
      }),
      [fe, ye] = r(!1),
      [he, we] = r(!1),
      [be, Se] = r(null),
      ge = s(!1),
      Ee = s(null),
      {
        anchorRefs: Ae,
        setActiveAnchor: _e
      } = z(l),
      Oe = s(!1),
      [ke, Te] = r([]),
      Le = s(!1),
      Ce = w || h.includes("click"),
      Re = Ce || (null == H ? void 0 : H.click) || (null == H ? void 0 : H.dblclick) || (null == H ? void 0 : H.mousedown),
      xe = H ? {
        ...H
      } : {
        mouseover: !0,
        focus: !0,
        mouseenter: !1,
        click: !1,
        dblclick: !1,
        mousedown: !1
      };
    !H && Ce && Object.assign(xe, {
      mouseenter: !1,
      focus: !1,
      mouseover: !1,
      click: !0
    });
    const Ne = M ? {
      ...M
    } : {
      mouseout: !0,
      blur: !0,
      mouseleave: !1,
      click: !1,
      dblclick: !1,
      mouseup: !1
    };
    !M && Ce && Object.assign(Ne, {
      mouseleave: !1,
      blur: !1,
      mouseout: !1
    });
    const $e = W ? {
      ...W
    } : {
      escape: I || !1,
      scroll: j || !1,
      resize: q || !1,
      clickOutsideAnchor: Re || !1
    };
    P && (Object.assign(xe, {
      mouseover: !1,
      focus: !1,
      mouseenter: !1,
      click: !1,
      dblclick: !1,
      mousedown: !1
    }), Object.assign(Ne, {
      mouseout: !1,
      blur: !1,
      mouseleave: !1,
      click: !1,
      dblclick: !1,
      mouseup: !1
    }), Object.assign($e, {
      escape: !1,
      scroll: !1,
      resize: !1,
      clickOutsideAnchor: !1
    })), C(() => (Le.current = !0, () => {
      Le.current = !1;
    }), []);
    const Ie = e => {
      Le.current && (e && we(!0), setTimeout(() => {
        Le.current && (null == Q || Q(e), void 0 === Z && ye(e));
      }, 10));
    };
    o(() => {
      if (void 0 === Z) return () => null;
      Z && we(!0);
      const e = setTimeout(() => {
        ye(Z);
      }, 10);
      return () => {
        clearTimeout(e);
      };
    }, [Z]), o(() => {
      if (fe !== ge.current) if (R(pe), ge.current = fe, fe) null == K || K();else {
        const e = (e => {
          const t = e.match(/^([\d.]+)(ms|s)$/);
          if (!t) return 0;
          const [, o, l] = t;
          return Number(o) * ("ms" === l ? 1 : 1e3);
        })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
        pe.current = setTimeout(() => {
          we(!1), Se(null), null == U || U();
        }, e + 25);
      }
    }, [fe]);
    const ze = e => {
        me(t => k(t, e) ? t : e);
      },
      je = function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : A;
        R(ue), he ? Ie(!0) : ue.current = setTimeout(() => {
          Ie(!0);
        }, e);
      },
      Be = function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : O;
        R(de), de.current = setTimeout(() => {
          Oe.current || Ie(!1);
        }, e);
      },
      De = e => {
        var t;
        if (!e) return;
        const o = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == o ? void 0 : o.isConnected)) return te(null), void _e({
          current: null
        });
        A ? je() : Ie(!0), te(o), _e({
          current: o
        }), R(de);
      },
      qe = () => {
        $ ? Be(O || 100) : O ? Be() : Ie(!1), R(ue);
      },
      He = _ref8 => {
        let {
          x: e,
          y: t
        } = _ref8;
        var o;
        const l = {
          getBoundingClientRect: () => ({
            x: e,
            y: t,
            width: 0,
            height: 0,
            top: t,
            left: e,
            right: e,
            bottom: t
          })
        };
        E({
          place: null !== (o = null == be ? void 0 : be.place) && void 0 !== o ? o : v,
          offset: m,
          elementReference: l,
          tooltipReference: se.current,
          tooltipArrowReference: ae.current,
          strategy: b,
          middlewares: S,
          border: oe,
          arrowSize: ne
        }).then(e => {
          ze(e);
        });
      },
      Me = e => {
        if (!e) return;
        const t = e,
          o = {
            x: t.clientX,
            y: t.clientY
          };
        He(o), Ee.current = o;
      },
      We = e => {
        var t;
        if (!fe) return;
        const o = e.target;
        if (!o.isConnected) return;
        if (null === (t = se.current) || void 0 === t ? void 0 : t.contains(o)) return;
        [document.querySelector(`[id='${d}']`), ...ke].some(e => null == e ? void 0 : e.contains(o)) || (Ie(!1), R(ue));
      },
      Pe = _(De, 50, !0),
      Ve = _(qe, 50, !0),
      Fe = e => {
        Ve.cancel(), Pe(e);
      },
      Ke = () => {
        Pe.cancel(), Ve();
      },
      Ue = n(() => {
        var e, t;
        const o = null !== (e = null == be ? void 0 : be.position) && void 0 !== e ? e : F;
        o ? He(o) : T ? Ee.current && He(Ee.current) : (null == ee ? void 0 : ee.isConnected) && E({
          place: null !== (t = null == be ? void 0 : be.place) && void 0 !== t ? t : v,
          offset: m,
          elementReference: ee,
          tooltipReference: se.current,
          tooltipArrowReference: ae.current,
          strategy: b,
          middlewares: S,
          border: oe,
          arrowSize: ne
        }).then(e => {
          Le.current && ze(e);
        });
      }, [fe, ee, Y, V, v, null == be ? void 0 : be.place, m, b, F, null == be ? void 0 : be.position, T, ne]);
    o(() => {
      var e, t;
      const o = new Set(Ae);
      ke.forEach(e => {
        (null == X ? void 0 : X(e)) || o.add({
          current: e
        });
      });
      const l = document.querySelector(`[id='${d}']`);
      l && !(null == X ? void 0 : X(l)) && o.add({
        current: l
      });
      const r = () => {
          Ie(!1);
        },
        n = L(ee),
        i = L(se.current);
      $e.scroll && (window.addEventListener("scroll", r), null == n || n.addEventListener("scroll", r), null == i || i.addEventListener("scroll", r));
      let c = null;
      $e.resize ? window.addEventListener("resize", r) : ee && se.current && (c = f(ee, se.current, Ue, {
        ancestorResize: !0,
        elementResize: !0,
        layoutShift: !0
      }));
      const s = e => {
        "Escape" === e.key && Ie(!1);
      };
      $e.escape && window.addEventListener("keydown", s), $e.clickOutsideAnchor && window.addEventListener("click", We);
      const a = [],
        u = e => Boolean((null == e ? void 0 : e.target) && (null == ee ? void 0 : ee.contains(e.target))),
        p = e => {
          fe && u(e) || De(e);
        },
        v = e => {
          fe && u(e) && qe();
        },
        m = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"],
        y = ["click", "dblclick", "mousedown", "mouseup"];
      Object.entries(xe).forEach(_ref9 => {
        let [e, t] = _ref9;
        t && (m.includes(e) ? a.push({
          event: e,
          listener: Fe
        }) : y.includes(e) && a.push({
          event: e,
          listener: p
        }));
      }), Object.entries(Ne).forEach(_ref10 => {
        let [e, t] = _ref10;
        t && (m.includes(e) ? a.push({
          event: e,
          listener: Ke
        }) : y.includes(e) && a.push({
          event: e,
          listener: v
        }));
      }), T && a.push({
        event: "pointermove",
        listener: Me
      });
      const h = () => {
          Oe.current = !0;
        },
        w = () => {
          Oe.current = !1, qe();
        },
        b = $ && (Ne.mouseout || Ne.mouseleave);
      return b && (null === (e = se.current) || void 0 === e || e.addEventListener("mouseover", h), null === (t = se.current) || void 0 === t || t.addEventListener("mouseout", w)), a.forEach(_ref11 => {
        let {
          event: e,
          listener: t
        } = _ref11;
        o.forEach(o => {
          var l;
          null === (l = o.current) || void 0 === l || l.addEventListener(e, t);
        });
      }), () => {
        var e, t;
        $e.scroll && (window.removeEventListener("scroll", r), null == n || n.removeEventListener("scroll", r), null == i || i.removeEventListener("scroll", r)), $e.resize ? window.removeEventListener("resize", r) : null == c || c(), $e.clickOutsideAnchor && window.removeEventListener("click", We), $e.escape && window.removeEventListener("keydown", s), b && (null === (e = se.current) || void 0 === e || e.removeEventListener("mouseover", h), null === (t = se.current) || void 0 === t || t.removeEventListener("mouseout", w)), a.forEach(_ref12 => {
          let {
            event: e,
            listener: t
          } = _ref12;
          o.forEach(o => {
            var l;
            null === (l = o.current) || void 0 === l || l.removeEventListener(e, t);
          });
        });
      };
    }, [ee, Ue, he, Ae, ke, H, M, W, Ce, A, O]), o(() => {
      var e, t;
      let o = null !== (t = null !== (e = null == be ? void 0 : be.anchorSelect) && void 0 !== e ? e : p) && void 0 !== t ? t : "";
      !o && l && (o = `[data-tooltip-id='${l.replace(/'/g, "\\'")}']`);
      const r = new MutationObserver(e => {
        const t = [],
          r = [];
        e.forEach(e => {
          if ("attributes" === e.type && "data-tooltip-id" === e.attributeName) {
            e.target.getAttribute("data-tooltip-id") === l ? t.push(e.target) : e.oldValue === l && r.push(e.target);
          }
          if ("childList" === e.type) {
            if (ee) {
              const t = [...e.removedNodes].filter(e => 1 === e.nodeType);
              if (o) try {
                r.push(...t.filter(e => e.matches(o))), r.push(...t.flatMap(e => [...e.querySelectorAll(o)]));
              } catch (e) {}
              t.some(e => {
                var t;
                return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, ee)) && (we(!1), Ie(!1), te(null), R(ue), R(de), !0);
              });
            }
            if (o) try {
              const l = [...e.addedNodes].filter(e => 1 === e.nodeType);
              t.push(...l.filter(e => e.matches(o))), t.push(...l.flatMap(e => [...e.querySelectorAll(o)]));
            } catch (e) {}
          }
        }), (t.length || r.length) && Te(e => [...e.filter(e => !r.includes(e)), ...t]);
      });
      return r.observe(document.body, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["data-tooltip-id"],
        attributeOldValue: !0
      }), () => {
        r.disconnect();
      };
    }, [l, p, null == be ? void 0 : be.anchorSelect, ee]), o(() => {
      Ue();
    }, [Ue]), o(() => {
      if (!(null == G ? void 0 : G.current)) return () => null;
      const e = new ResizeObserver(() => {
        setTimeout(() => Ue());
      });
      return e.observe(G.current), () => {
        e.disconnect();
      };
    }, [Y, null == G ? void 0 : G.current]), o(() => {
      var e;
      const t = document.querySelector(`[id='${d}']`),
        o = [...ke, t];
      ee && o.includes(ee) || te(null !== (e = ke[0]) && void 0 !== e ? e : t);
    }, [d, ke, ee]), o(() => (J && Ie(!0), () => {
      R(ue), R(de);
    }), []), o(() => {
      var e;
      let t = null !== (e = null == be ? void 0 : be.anchorSelect) && void 0 !== e ? e : p;
      if (!t && l && (t = `[data-tooltip-id='${l.replace(/'/g, "\\'")}']`), t) try {
        const e = Array.from(document.querySelectorAll(t));
        Te(e);
      } catch (e) {
        Te([]);
      }
    }, [l, p, null == be ? void 0 : be.anchorSelect]), o(() => {
      ue.current && (R(ue), je(A));
    }, [A]);
    const Xe = null !== (ce = null == be ? void 0 : be.content) && void 0 !== ce ? ce : Y,
      Ye = fe && Object.keys(ve.tooltipStyles).length > 0;
    return a(t, () => ({
      open: e => {
        if (null == e ? void 0 : e.anchorSelect) try {
          document.querySelector(e.anchorSelect);
        } catch (t) {
          return void console.warn(`[react-tooltip] "${e.anchorSelect}" is not a valid CSS selector`);
        }
        Se(null != e ? e : null), (null == e ? void 0 : e.delay) ? je(e.delay) : Ie(!0);
      },
      close: e => {
        (null == e ? void 0 : e.delay) ? Be(e.delay) : Ie(!1);
      },
      activeAnchor: ee,
      place: ve.place,
      isOpen: Boolean(he && !x && Xe && Ye)
    })), he && !x && Xe ? e.createElement(g, {
      id: l,
      role: ie,
      className: y("react-tooltip", B.tooltip, D.tooltip, D[u], i, `react-tooltip__place-${ve.place}`, B[Ye ? "show" : "closing"], Ye ? "react-tooltip__show" : "react-tooltip__closing", "fixed" === b && B.fixed, $ && B.clickable),
      onTransitionEnd: e => {
        R(pe), fe || "opacity" !== e.propertyName || (we(!1), Se(null), null == U || U());
      },
      style: {
        ...V,
        ...ve.tooltipStyles,
        opacity: void 0 !== le && Ye ? le : void 0
      },
      ref: se
    }, Xe, e.createElement(g, {
      className: y("react-tooltip-arrow", B.arrow, D.arrow, c, N && B.noArrow),
      style: {
        ...ve.tooltipArrowStyles,
        background: re ? `linear-gradient(to right bottom, transparent 50%, ${re} 50%)` : void 0,
        "--rt-arrow-size": `${ne}px`
      },
      ref: ae
    })) : null;
  },
  H = _ref13 => {
    let {
      content: t
    } = _ref13;
    return e.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: t
      }
    });
  },
  M = e.forwardRef((_ref14, Q) => {
    let {
      id: t,
      anchorId: l,
      anchorSelect: n,
      content: i,
      html: c,
      render: a,
      className: u,
      classNameArrow: d,
      variant: p = "dark",
      place: v = "top",
      offset: m = 10,
      wrapper: f = "div",
      children: h = null,
      events: w = ["hover"],
      openOnClick: b = !1,
      positionStrategy: S = "absolute",
      middlewares: g,
      delayShow: E = 0,
      delayHide: _ = 0,
      float: O = !1,
      hidden: k = !1,
      noArrow: T = !1,
      clickable: L = !1,
      closeOnEsc: C = !1,
      closeOnScroll: R = !1,
      closeOnResize: x = !1,
      openEvents: N,
      closeEvents: $,
      globalCloseEvents: I,
      imperativeModeOnly: j = !1,
      style: B,
      position: D,
      isOpen: M,
      defaultIsOpen: W = !1,
      disableStyleInjection: P = !1,
      border: V,
      opacity: F,
      arrowColor: K,
      arrowSize: U,
      setIsOpen: X,
      afterShow: Y,
      afterHide: G,
      disableTooltip: Z,
      role: J = "tooltip"
    } = _ref14;
    const [ee, te] = r(i),
      [oe, le] = r(c),
      [re, ne] = r(v),
      [ie, ce] = r(p),
      [se, ae] = r(m),
      [ue, de] = r(E),
      [pe, ve] = r(_),
      [me, fe] = r(O),
      [ye, he] = r(k),
      [we, be] = r(f),
      [Se, ge] = r(w),
      [Ee, Ae] = r(S),
      [_e, Oe] = r(null),
      [ke, Te] = r(null),
      Le = s(P),
      {
        anchorRefs: Ce,
        activeAnchor: Re
      } = z(t),
      xe = e => null == e ? void 0 : e.getAttributeNames().reduce((t, o) => {
        var l;
        if (o.startsWith("data-tooltip-")) {
          t[o.replace(/^data-tooltip-/, "")] = null !== (l = null == e ? void 0 : e.getAttribute(o)) && void 0 !== l ? l : null;
        }
        return t;
      }, {}),
      Ne = e => {
        const t = {
          place: e => {
            var t;
            ne(null !== (t = e) && void 0 !== t ? t : v);
          },
          content: e => {
            te(null != e ? e : i);
          },
          html: e => {
            le(null != e ? e : c);
          },
          variant: e => {
            var t;
            ce(null !== (t = e) && void 0 !== t ? t : p);
          },
          offset: e => {
            ae(null === e ? m : Number(e));
          },
          wrapper: e => {
            var t;
            be(null !== (t = e) && void 0 !== t ? t : f);
          },
          events: e => {
            const t = null == e ? void 0 : e.split(" ");
            ge(null != t ? t : w);
          },
          "position-strategy": e => {
            var t;
            Ae(null !== (t = e) && void 0 !== t ? t : S);
          },
          "delay-show": e => {
            de(null === e ? E : Number(e));
          },
          "delay-hide": e => {
            ve(null === e ? _ : Number(e));
          },
          float: e => {
            fe(null === e ? O : "true" === e);
          },
          hidden: e => {
            he(null === e ? k : "true" === e);
          },
          "class-name": e => {
            Oe(e);
          }
        };
        Object.values(t).forEach(e => e(null)), Object.entries(e).forEach(_ref15 => {
          let [e, o] = _ref15;
          var l;
          null === (l = t[e]) || void 0 === l || l.call(t, o);
        });
      };
    o(() => {
      te(i);
    }, [i]), o(() => {
      le(c);
    }, [c]), o(() => {
      ne(v);
    }, [v]), o(() => {
      ce(p);
    }, [p]), o(() => {
      ae(m);
    }, [m]), o(() => {
      de(E);
    }, [E]), o(() => {
      ve(_);
    }, [_]), o(() => {
      fe(O);
    }, [O]), o(() => {
      he(k);
    }, [k]), o(() => {
      Ae(S);
    }, [S]), o(() => {
      Le.current !== P && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
    }, [P]), o(() => {
      "undefined" != typeof window && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", {
        detail: {
          disableCore: "core" === P,
          disableBase: P
        }
      }));
    }, []), o(() => {
      var e;
      const o = new Set(Ce);
      let r = n;
      if (!r && t && (r = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), r) try {
        document.querySelectorAll(r).forEach(e => {
          o.add({
            current: e
          });
        });
      } catch (e) {
        console.warn(`[react-tooltip] "${r}" is not a valid CSS selector`);
      }
      const i = document.querySelector(`[id='${l}']`);
      if (i && o.add({
        current: i
      }), !o.size) return () => null;
      const c = null !== (e = null != ke ? ke : i) && void 0 !== e ? e : Re.current,
        s = new MutationObserver(e => {
          e.forEach(e => {
            var t;
            if (!c || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
            const o = xe(c);
            Ne(o);
          });
        }),
        a = {
          attributes: !0,
          childList: !1,
          subtree: !1
        };
      if (c) {
        const e = xe(c);
        Ne(e), s.observe(c, a);
      }
      return () => {
        s.disconnect();
      };
    }, [Ce, Re, ke, l, n]), o(() => {
      (null == B ? void 0 : B.border) && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), V && !A("border", `${V}`) && console.warn(`[react-tooltip] "${V}" is not a valid \`border\`.`), (null == B ? void 0 : B.opacity) && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), F && !A("opacity", `${F}`) && console.warn(`[react-tooltip] "${F}" is not a valid \`opacity\`.`);
    }, []);
    let $e = h;
    const Ie = s(null);
    if (a) {
      const t = a({
        content: (null == ke ? void 0 : ke.getAttribute("data-tooltip-content")) || ee || null,
        activeAnchor: ke
      });
      $e = t ? e.createElement("div", {
        ref: Ie,
        className: "react-tooltip-content-wrapper"
      }, t) : null;
    } else ee && ($e = ee);
    oe && ($e = e.createElement(H, {
      content: oe
    }));
    const ze = {
      forwardRef: Q,
      id: t,
      anchorId: l,
      anchorSelect: n,
      className: y(u, _e),
      classNameArrow: d,
      content: $e,
      contentWrapperRef: Ie,
      place: re,
      variant: ie,
      offset: se,
      wrapper: we,
      events: Se,
      openOnClick: b,
      positionStrategy: Ee,
      middlewares: g,
      delayShow: ue,
      delayHide: pe,
      float: me,
      hidden: ye,
      noArrow: T,
      clickable: L,
      closeOnEsc: C,
      closeOnScroll: R,
      closeOnResize: x,
      openEvents: N,
      closeEvents: $,
      globalCloseEvents: I,
      imperativeModeOnly: j,
      style: B,
      position: D,
      isOpen: M,
      defaultIsOpen: W,
      border: V,
      opacity: F,
      arrowColor: K,
      arrowSize: U,
      setIsOpen: X,
      afterShow: Y,
      afterHide: G,
      disableTooltip: Z,
      activeAnchor: ke,
      setActiveAnchor: e => Te(e),
      role: J
    };
    return e.createElement(q, {
      ...ze
    });
  });
"undefined" != typeof window && window.addEventListener("react-tooltip-inject-styles", e => {
  e.detail.disableCore || S({
    css: `:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s;--rt-arrow-size:8px}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit;z-index:-1}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}`,
    type: "core"
  }), e.detail.disableBase || S({
    css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:var(--rt-arrow-size);height:var(--rt-arrow-size)}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`,
    type: "base"
  });
});
export { M as Tooltip, I as TooltipProvider, j as TooltipWrapper, g as removeStyle };